import React, { useState } from 'react';
// import Rating from '../Rating';

export default function Testimonial() {
  const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = tabNumber => {
    setActiveTab(tabNumber);
  };
  return (
    <div className="cs_tabs cs_style1"  data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-offset="200">
      <ul className="cs_tab_links">
        <li className={activeTab === 1 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(1)}>
            <div className="cs_testimonial_1_avatar">
              {/* <img src="/images/home_1/avatar_1.png" alt="Avatar" /> */}
               <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/lb.svg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">-Mr. Joe</h3>
                <p className="cs_heading_color mb-0">Lebanon</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 2 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(2)}>
            <div className="cs_testimonial_1_avatar">
              {/* <img src="/images/home_1/avatar_2.png" alt="Avatar" /> */}
                <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/in.svg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Khamkar</h3>
                <p className="cs_heading_color mb-0">India</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 3 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(3)}>
            <div className="cs_testimonial_1_avatar">
              {/* <img src="/images/home_1/avatar_3.png" alt="Avatar" /> */}
                  <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/eu.svg" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">Dr.Michael</h3>
                <p className="cs_heading_color mb-0">Europe</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className="cs_tab_body">
        {activeTab === 1 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
             It has been a pleasure working with Precision Orthocad. 
             The quality of his work is consistently excellent, he always delivers cases 
             quickly, and his customer service is outstanding. He is reliable, professional, 
             and easy to work with. I truly appreciate the great experience I've had 
             working with him and would highly recommend his services.
            </p>
            {/* <Rating ratingNumber={4.9} /> */}
          </div>
        )}
        {activeTab === 2 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
              It has been a great experience working with Precision for clear aligner design services. Their treatment setups are consistently accurate, well-planned, and clinically sound, making case reviews efficient and straightforward. Turnaround times are always fast, and the quality of work remains exceptional across every case. The team is responsive, professional, and attentive to feedback, ensuring a smooth workflow from start to finish. I highly appreciate their expertise and dedication to delivering outstanding clear aligner solutions and would highly recommend their services.
            </p>
            {/* <Rating ratingNumber={4.0} /> */}
          </div>
        )}
        {activeTab === 3 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
              "We've worked with Precision Orthocad on numerous aligner cases, and the consistency has been impressive. The setups are precise, revisions are handled quickly, and communication is always professional. It's reassuring to have a partner who understands clinical expectations and delivers on time. We look forward to continuing our collaboration."
            </p>
            {/* <Rating ratingNumber={4.4} /> */}
          </div>
        )}
      </div>
    </div>
  );
}
